module.exports = require("./de-BE");